import { render } from "./BarraAcaoMobile.vue?vue&type=template&id=16a24828&scoped=true&ts=true"
import script from "./BarraAcaoMobile.vue?vue&type=script&lang=ts"
export * from "./BarraAcaoMobile.vue?vue&type=script&lang=ts"

import "./BarraAcaoMobile.vue?vue&type=style&index=0&id=16a24828&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a24828"]])

export default __exports__